import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import template from './right-side-item-content.vue';

import RightSideDescription from '../right-side-description/index';
import RightSideImages from '../right-side-images/index';

@Component({
    mixins: [template],
    components: {
        RightSideDescription,
        RightSideImages
    }
})

export default class RightSideItemContent extends Vue {

    @Prop(Object) readonly auctionData!: object;

    created() {

    }

    mounted() {

    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/components/right-side-item-content/index.ts